import React,{useState,useEffect,useContext} from 'react'
import { useLocation } from "react-router-dom";
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import { ManagerAuthContext } from "../context/AuthManager";
import Modal from "react-bootstrap/Modal";
import moment from "jalali-moment";

export const FolderUserProfile = () => {

    const { currentUserRF } = useContext(ManagerAuthContext);

    const location = useLocation();
    const propsData = location.state;

    const [userList, setUserList] = useState([]);

    var dataT = 0;
    dataT  = 1405 - propsData.insu.slice(0,4) ;

  //alert(dataT.slice(6))
  // console.log(dataT.slice(0,4))

 useEffect(() => {
    const getAllProductsRT = async () => {
        const res = await fetch(
        `https://clinic.salamatpayanew.ir/admin/filterPatWrite/${currentUserRF.nezam}&${propsData.meli}`
        );
        setUserList(await res.json());
    };
      getAllProductsRT();
  }, [userList]);

 
const [canvace,setDescs] = useState('')

const updateField = () => {
    userList.map((item) => {setDescs(item.descs)})
}

const [naz,setNaz] = useState('');

const updateWritePat = async () => {
        await axios.put(`https://clinic.salamatpayanew.ir/admin/updatePatWrite/${currentUserRF.nezam}&${propsData.meli}`,{
            descs:canvace,
            naz:naz
        }).then(() =>{
            toast.success("ثبت با موفقیت انجام شد")
        }).catch(() =>{
            toast.warning("خطا در ثبت اطلاعات لطفا دوباره سعی کنید")
        })
 }

 const [less, setless] = useState([]);

 useEffect(() => {
   const getAllFiled = async () => {
     const res = await fetch(`https://clinic.salamatpayanew.ir/admin/ListServicesDiagnoz/${currentUserRF.nezam}`);
     setless(await res.clone().json());
   };
   getAllFiled();
 }, []);

if (currentUserRF.meli === null) {
 } else {

  return (
    <>
    <section class="m-0 content" dir='rtl'>
  <div class="d-flex flex-column justify-content-start align-items-center">
    <div class="card">
        <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
        <div class="d-flex flex-column justify-content-start card-title-container">
            <div class="card-title text-secondary">خلاصه پرونده</div>
            <p></p>           
            <p></p>
            <br />
            <div className="card">
                <div className="container">
                <div className="row">
                <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-40">
                             نام و نام خانوادگی : <span style={{color:'blue'}}>{propsData.name}</span>
                        </div>
                        <div class="custom-form-control form-group position-relative w-40">
                           کد ملی : <span style={{color:'blue'}}>{propsData.meli}</span>
                        </div>
       <div class="custom-form-control form-group position-relative w-40">
                        <select style={{borderRadius:"20px"}}
                      id="selce"
                     onChange={(e) => setNaz(e.target.value)}
                      name="fieldID"
                    >
                      <option style={{borderRadius:"20px"}} className="pok" value={"23e0w"}>انتخاب کنید</option>
                      {less.map((item) => {
                        return <option value={item.name}>{item.name}</option>;
                      })}
                    </select>
        </div>
                        <div class="custom-form-control form-group position-relative w-40">
                            سن :  <span style={{color:'blue'}} dir='rtl'>{dataT}</span>
                        </div>
                        <div class="custom-form-control form-group position-relative w-40">
                        <button className='btn btn-success' onClick={updateField}>نمایش پرونده</button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
<p></p>
        <div className="card">
                <div className="container">
                <div className="row">
                <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                    <h4 className='pok'>نوع تشخیص : {userList.map((item) => item.naz)}</h4>
                    </div>
                    </div>
                    </div>
                    </div>
 <div class="form-group position-relative w-100 t-16" dir='ltr'>
    <textarea  class="form-control p-3 h-50"  id="" cols="30" rows="10"
      style={{color:'blue'}}  placeholder="ٌWrite" value={canvace}  onChange={(e)=> setDescs(e.target.value)} >
    </textarea>
        </div>
        <p></p>
        <button className='btn btn-info'  onClick={updateWritePat}>ثبت اطلاعات</button>
    </div>    
</div>
</section>

<ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  )
    }
}

